import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AddedToCartModal from './components/AddedToCartModalComponent'
import JabraButton from './components/JabraButton'
import JabraInput from './components/transitional/JabraInput'
import JabraProgressLinear from './components/JabraProgressLinear'
import JabraDropdown from './components/JabraDropdown'
import JabraStepper from './components/JabraStepper'
import JabraSignup from './components/SignupComponent'
import JabraBreadcrumbs from './components/JabraBreadcrumbs'
import BodyText from './components/non-routed/BodyText'
import DownloadSection from './components/non-routed/DownloadSection'
import VueAnalytics from 'vue-analytics'
import BottomShape from './components/BottomShape'
import TopShape from './components/TopShape'
import Lightbox from './components/Lightbox'
import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)
import SmartBanner from 'smart-app-banner'
import { VueperSlides, VueperSlide } from 'vueperslides'

import 'vueperslides/dist/vueperslides.css'
import 'smart-app-banner/dist/smart-app-banner.css'


import "./scss/_custom.scss"
import 'bootstrap'


import {
    INIT_STORE,
    PRE_INIT_STORE,
    GA_UID,
} from './services/constants'
import {registerFilters} from './filters/filters'

//// FontAwesome imports
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import fontawesome from '@fortawesome/fontawesome'
import falAngleDown from '@fortawesome/fontawesome-pro-light/faAngleDown'
import falChevronLeft from '@fortawesome/fontawesome-pro-light/faChevronLeft'
import falChevronRight from '@fortawesome/fontawesome-pro-light/faChevronRight'
import falStar from '@fortawesome/fontawesome-pro-light/faStar'
import falShoppingCart from '@fortawesome/fontawesome-pro-light/faShoppingCart'
import falPlayCircle from '@fortawesome/fontawesome-pro-light/faPlayCircle'
import falClock from '@fortawesome/fontawesome-pro-light/faClock'
import falHeadphones from '@fortawesome/fontawesome-pro-light/faHeadphones'
import falVideo from '@fortawesome/fontawesome-pro-light/faVideo'
import falFileAlt from '@fortawesome/fontawesome-pro-light/faFileAlt'
import falPrint from '@fortawesome/fontawesome-pro-light/faPrint'
import falRedo from '@fortawesome/fontawesome-pro-light/faRedo'
import falTrashAlt from '@fortawesome/fontawesome-pro-light/faTrashAlt'
import falSearch from '@fortawesome/fontawesome-pro-light/faSearch'
import falPencil from '@fortawesome/fontawesome-pro-light/faPencil'
import falSpinnerThird from '@fortawesome/fontawesome-pro-light/faSpinnerThird'
import falArrows from '@fortawesome/fontawesome-pro-light/faArrows'
import falArrowLeft from '@fortawesome/fontawesome-pro-light/faArrowLeft'
import falArrowRight from '@fortawesome/fontawesome-pro-light/faArrowRight'
import fasStar from '@fortawesome/fontawesome-pro-solid/faStar'
import fabYoutube from '@fortawesome/fontawesome-free-brands/faYoutube'
import fabApple from '@fortawesome/fontawesome-free-brands/faApple'
import fabAndroid from '@fortawesome/fontawesome-free-brands/faAndroid'
import fabTwitter from '@fortawesome/fontawesome-free-brands/faTwitter'
import fabFacebookF from '@fortawesome/fontawesome-free-brands/faFacebookF'

import vueNumeralFilterInstaller from 'vue-numeral-filter';

Vue.use(vueNumeralFilterInstaller, { locale: 'es' });

import 'video.js/dist/video-js.min.css'

Vue.config.productionTip = false

registerFilters(Vue)

Vue.component('font-awesome-icon', FontAwesomeIcon)
fontawesome.library.add(
    falAngleDown,
    falChevronLeft,
    falChevronRight,
    falStar,
    falShoppingCart,
    falPlayCircle,
    falClock,
    falHeadphones,
    falVideo,
    falFileAlt,
    falPrint,
    falRedo,
    falTrashAlt,
    falSearch,
    falPencil,
    falSpinnerThird,
    falArrows,
    falArrowLeft,
    falArrowRight,
    fasStar,
    fabYoutube,
    fabTwitter,
    fabFacebookF,
    fabApple,
    fabAndroid,
)

Vue.use(VueAnalytics, {
    id: GA_UID,
    router,
    debug: {
        enabled: false
    }
})

Vue.component('jabra-breadcrumbs', JabraBreadcrumbs)
Vue.component('jabra-btn', JabraButton)
Vue.component('jabra-input', JabraInput)
Vue.component('jabra-progress-linear', JabraProgressLinear)
Vue.component('jabra-dropdown', JabraDropdown)
Vue.component('jabra-stepper', JabraStepper)
Vue.component('jabra-signup', JabraSignup)
Vue.component('jabra-added-to-cart-modal', AddedToCartModal)
Vue.component('jabra-body-text-binding', BodyText)
Vue.component('jabra-download-section', DownloadSection)
Vue.component('bottom-shape', BottomShape)
Vue.component('top-shape', TopShape)
Vue.component('lightbox', Lightbox)
Vue.component('vueper-slides', VueperSlides)
Vue.component('vueper-slide', VueperSlide)


store.dispatch(PRE_INIT_STORE)

const fixIdScrolling = {
    watch: {
        $route(to, from) {
            const currentRoute = this.$router.currentRoute;
            const idToScrollTo = currentRoute.hash;
            this.$nextTick(() => {
                if (idToScrollTo && document.querySelector(idToScrollTo)) {
                    document.querySelector(idToScrollTo).scrollIntoView();
                }
            });
        },
    },
};

new Vue({
    mixins: [fixIdScrolling],
    router,
    store,
    render: h => h(App),
    mounted: function () {
        this.$store.dispatch(INIT_STORE)
    },
    created() {
        new SmartBanner({
            daysHidden: 15,   // days to hide banner after close button is clicked (defaults to 15)
            daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
            title: 'Jabrutouch',
            author: 'Jabrutouch',
            button: 'VIEW',
            store: {
              ios: 'https://apps.apple.com/il/app/jabrutouch/id1488439011',
              android: 'https://play.google.com/store/apps/details?id=co.il.jabrutouch',
            },
            price: {
              ios: 'FREE',
              android: 'FREE',
              windows: 'FREE'
            }
            // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
            // , icon: '' // full path to icon image if not using website icon image
          })

    },
}).$mount('#app')